import React, {Component} from 'react';
import getFieldFactory from "../../Endpoint/FieldFactory";
import FieldGroups from "../FieldGroups";
import {addSubField} from "../../../../../store/actions/subFields";
import {changeGroupField} from "../../../../../store/actions/groupFields";
import {connect} from "react-redux";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";

const TaxonomiesFilter = (props) => {

	const {addSubField, group, changeGroupField} = props;

	const newTaxonomy = {
		name: 'term',
		label: 'Term',
		fields: [
			getFieldFactory().getSourceField(),
			getFieldFactory().getValueInputType(),
			{
				id: 'taxonomy',
				inputType: 'select',
				source: 'taxonomies',
				sourceName: 'name',
				sourceValue: 'value',
				value: '',
				label: 'Taxonomy',
				defaultValue: 'Select a taxonomy',
				dynamic: false
			},
			{
				id: 'field-type',
				inputType: 'select',
				source: 'termFieldTypes',
				sourceName: 'name',
				sourceValue: 'value',
				value: '',
				label: 'Field type',
				defaultValue: 'Select a field type',
				dynamic: false
			},
			getFieldFactory().getParametersField(),
			getFieldFactory().getDynamicField(),
      {
        id: 'customFieldName',
        inputType: 'input',
        value: '',
        label: 'Custom Field Name',
        dynamic: false
      },
      {
        id: 'customFieldValue',
        inputType: 'input',
        value: '',
        label: 'Custom Field Value',
        dynamic: false
      },
		],
	};

	return (
		<React.Fragment>

			<FieldGroupContext.Consumer>

				{({ endpointId, endpoint, currentItem, action }) => (<React.Fragment>
					<h3>Taxonomies ({endpoint[action][currentItem].taxonomies.length})</h3>

					<button onClick={() => addSubField(endpointId, [ newTaxonomy ], currentItem, group, action)} className="button-secondary">
						Add term
					</button>

					<FieldGroups group={group}/>

				</React.Fragment>)}
			</FieldGroupContext.Consumer>
		</React.Fragment>
	);
};

const mapStateToProps = ( state ) => ( state );

const mapDispatchToProps = dispatch => ({
	addSubField: ( endpointId, field, currentItem, group, parentGroup ) => dispatch( addSubField( endpointId, field, currentItem, group, parentGroup ) ),
	changeGroupField: ( endpointId, group, index, field, value ) => dispatch( changeGroupField( endpointId, group, index, field, value ) )
});

export default connect( mapStateToProps, mapDispatchToProps )(TaxonomiesFilter);
